import flatten from 'flat';

import routeTemplates from './templates';

const flattenedRouteTemplates = flatten(routeTemplates);
const rootTemplateParts = Object.keys(flatten(routeTemplates))
  .map(templateKey => {
    let template = flattenedRouteTemplates[templateKey];
    if (template) {
      const parts = template.split('/');
      const rootPart = template.startsWith('/')
        ? parts.length > 1 ? parts[1] : null
        : parts.length > 0 ? parts[0] : null;
      return rootPart && rootPart.indexOf(':') < 0 ? rootPart : null;
    }

    return null;
  })
  .filter(Boolean)
  .filter((part, index, arr) => arr.indexOf(part) === index);

export default rootTemplateParts;
